// @flow

import createApiModule from "../create-api-module";

const { reducer, actions } = createApiModule(
    "allTemplates",
    () => `/ays-venue-facility-management/templates`,
);
export const ERROR = "Error while fetching templates";
export const load = actions.load;
export const clear = actions.clear;
export const refetch = actions.refetch;
export default reducer;
